<template>
    <div class="discovers">
        <div class=" discover" v-for="(item, index) in discover" :key="index" :class="{'dark': !item.base}">
            <figure><img :src="item.image.url" :alt="item.title"></figure>
            <div class="discover-box">
                <h2>{{ item.title }}</h2>
                <p v-html="item.description"></p>
                <router-link :to="item.url" tag="button" class="button">{{ item.button }}</router-link>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: "Discover",
    // data(){
    //     return{
    //         discover: {
    //             img: 'https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/images%2Fvcg.jpg?alt=media&token=848395a2-d01a-4434-8c0b-21f12a639f3e',
    //         }
    //     }
    // }
    props: {
        discover: Array
    }
}
</script>